module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/centennial-592.8d92b5dcbe928424.jpg"+" 592w",
        images: [{path: "https://static.sniffspot.com/packs/img/centennial-592.8d92b5dcbe928424.jpg",width: 592,height: 592}],
        src: "https://static.sniffspot.com/packs/img/centennial-592.8d92b5dcbe928424.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/centennial-592.8d92b5dcbe928424.jpg"},
        
        width: 592,
        height: 592
      }